import { Directive, Input } from '@angular/core';

class StringService {
    static capitalize (word: string): string {
        if (word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }
        return word;
    }

    static camelize (str: string): string {
        const arr = str.split('_');
        const capital = arr.map((item, index) =>
            index
                ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()
                : item,
        );

        return capital.join('');
    }

    static removeWhiteSpaces (input: string): string {
        return input.replace(/\s+/g, '');
    }

    static escapeRegExp (input: string): string {
        return input ? input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '';
    }
}

/**
 * required @Directive decorator so that angular knows there are other angular decorators within this class
 * https://github.com/angular/angular/issues/35295
 */
@Directive()
export abstract class BaseFieldComponent {
    /**
     * Pass the value that is expected to be rendered as "id" attribute on input elements
     * For example:
     * <input id="domainName" />
     * then the binding should be [monId]="'domainName'"
     */
    @Input() monId: string = '';
    @Input() name: string = '';

    getLabelForId (label: string): string {
        if (this.monId) {
            return this.monId;
        }
        if (!label) {
            return Math.random().toString(16)
                .slice(2);
        }
        return StringService.removeWhiteSpaces(label);
    }
}
